import WebMarkdown, { type Components } from "react-markdown";

const components: Components = {
  a: ({ children, href, title, ...props }: React.ComponentProps<"a">) => {
    return (
      <a
        href={href}
        title={title}
        className="text-brand-primary"
        children={children}
        {...props}
      />
    );
  },
};

export function Markdown({ body }: { body: string }) {
  return <WebMarkdown components={components}>{body}</WebMarkdown>;
}
